import chatbotRequest from '@/service/channel/http'
import type { DashboardAgentReq, DashboardAgentRes } from '../type/getDashboardAgent'

export function getDashboardAgentApi(data: DashboardAgentReq): Promise<DashboardAgentRes> {
    return chatbotRequest<DashboardAgentRes, DashboardAgentReq, DashboardAgentRes>({
        url: '/api/dashboard/agent',
        method: 'post',
        data,
    })
}